import React, { useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Container, Form, Row, Col } from "react-bootstrap";
import SvgIcon from '@material-ui/core/SvgIcon';
import Hand from '../icons/Hand.svg';
import { StyledRadioInput } from "../../../Helpers/Inputs/index";
import { CALIFORNIA, CONNECTICUT, DISTRICT_OF_COLUMBIA, MINNESOTA, PENNSYLVANIA, VERMONT } from '../../../Helpers/Constants/States';
import { string, object, array as yuparray } from 'yup';
import IneligibleForm from '../Helpers/Input/IneligibleForm';
import BackNext from '../../Common/SubComponents/BackNext';
import { customValidators } from '../../../Helpers/Validators/customValidators'
const empStatusSelectedState = [CALIFORNIA, CONNECTICUT, DISTRICT_OF_COLUMBIA, MINNESOTA, PENNSYLVANIA, VERMONT];
const existingHealthInsuranceState = [CALIFORNIA, CONNECTICUT, DISTRICT_OF_COLUMBIA, MINNESOTA, PENNSYLVANIA, VERMONT];
const existingMedicareState = [CALIFORNIA, MINNESOTA];
const ineligibleCoverage = ["namedSpousePremium", "oneParentFamilyPremium", "twoParentFamilyPremium"];

export default function Eligibility(props) {
    const getIneligibleNamesOptions = () => {

        const ineligibleNames = [{ value: "Myself", label: "Myself" }];

        if (props.quoter.plan === "namedSpousePremium") {
            ineligibleNames.push({ value: "Spouse", label: "Spouse" });
        }

        if (props.quoter.plan === "oneParentFamilyPremium") {
            ineligibleNames.push({ value: "Dependent Child", label: "Dependent Child" });
        }

        if (props.quoter.plan === "twoParentFamilyPremium") {
            ineligibleNames.push({ value: "Spouse", label: "Spouse" });
            ineligibleNames.push({ value: "Dependent Child", label: "Dependent Child" });
        }

        return ineligibleNames;
    }
    const ineligibleDefault = [
        {
            type: '',
            name: [],
            numberOfChildren: '',
            nameofChildren: [],
        },
    ];
    const state = props.basicInfo.state;

    const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
        validationSchema: Eligibility.ValidationSchema(props.quoter.plan),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    const getExistingHealthInsuranceLabel = () => {
        let label;
        if (state === CALIFORNIA) {
            label = "Are you or each person proposed for coverage, currently covered by a hospital or medical expense insurance, health care service plan, a health maintenance organization (HMO) contract, or major medical expense insurance?";
        } else if (state === CONNECTICUT) {
            label = "Are you (and, if family coverage is applied for, everyone to be insured) currently covered by a comprehensive health care policy, a major medical policy or other health plan?";
        } else if (state === DISTRICT_OF_COLUMBIA) {
            label = "Do you have comprehensive medical coverage including the minimum essential coverage required by the Affordable Care Act (ACA) or are you treated as having minimum essential coverage due to your status as a bona fide resident of any possession of the United States?";
        } else if (state === PENNSYLVANIA) {
            label = "Is everyone proposed for coverage covered by a comprehensive health care policy, a major medical policy, or other health plan?";
        } else if (state === VERMONT) {
            label = "Are you covered by a comprehensive health care policy, a major medical policy or a common health plan?";
        } else if (state === MINNESOTA) {
            label = 'Are you currently covered by a Major Medical Plan that meets the minimum standards of a "Qualified Plan" as defined in Minnesota Insurance Laws?';
        } else {
            label = "";
        }

        return label;
    }

    const getExistingMedicareLabel = () => {
        let label;
        if (state === CALIFORNIA) {
            label = 'Are you or anyone to be covered, currently covered by Medicare Parts A and B AND a Medicare supplement policy or certificate, or contract and coverage for excess charges under Part B?';
        } else if (state === MINNESOTA) {
            label = 'Are you covered by the MinnesotaCare Health Plan for the Uninsured?';
        } else {
            label = '';
        }

        return label;
    }

    
    
    useEffect(() => {
        props.onFieldChange("isVisible", true);
    }, []);


    useEffect(() => {
        register({ name: 'employmentStatus' });
        setValue('employmentStatus', props.formState.employmentStatus);

        register({ name: 'existingHealthInsurance' });
        setValue('existingHealthInsurance', props.formState.existingHealthInsurance);

        register({ name: 'existingMedicare' });
        setValue('existingMedicare', props.formState.existingMedicare);

        register({ name: 'existingMediCal' });
        setValue('existingMediCal', props.formState.existingMediCal);

        register({ name: 'acknowledgementMinimum' });
        setValue('acknowledgementMinimum', props.formState.acknowledgementMinimum);

        register({ name: 'acknowledgementLimited' });
        setValue('acknowledgementLimited', props.formState.acknowledgementLimited);

        register({ name: 'state' });
        setValue('state', state);

        props.formState.ineligible.forEach((ineligible, index) => {
            register({ name: `ineligible[${index}].type` });
            setValue(`ineligible[${index}].type`, ineligible.type);

            register({ name: `ineligible[${index}].name` });
            setValue(`ineligible[${index}].name`, ineligible.name);

            register({ name: `ineligible[${index}].numberOfChildren` });
            setValue(`ineligible[${index}].numberOfChildren`, ineligible.numberOfChildren);

            register({ name: `ineligible[${index}].nameofChildren` });
            setValue(`ineligible[${index}].nameofChildren`, ineligible.nameofChildren);
        });


    }, [register]);


    return (
        <Container fluid className='border-class'>
            <Form onSubmit={handleSubmit(props.onNext)}>
                <Row className="justify-content-center pt-3">
                    <Col lg={4}>
                        <div className="text-center mb-2 pt-4"><SvgIcon component={Hand} className="small-icons" color="primary" fontSize="large" /></div>
                        <div className="text-center mb-4 form-title">Eligibility</div>

                        {empStatusSelectedState.includes(state) &&
                            <Form.Group>
                                <p className="section-title">Are you, the Proposed Insured, currently reporting to work (not out on leave, FML, disability, hiatus, or layoff) with the employer listed on this application?</p>
                                <StyledRadioInput
                                    name="employmentStatus"
                                    id="employmentStatus"
                                    value={props.formState.employmentStatus}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={e => handleValueChange('employmentStatus', e)}
                                    errors={errors && errors.employmentStatus}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                />
                            </Form.Group>
                        }

                        {existingHealthInsuranceState.includes(state) &&
                            <Form.Group>
                                <p className="section-title">{getExistingHealthInsuranceLabel()}</p>
                                <StyledRadioInput
                                    name="existingHealthInsurance"
                                    id="existingHealthInsurance"
                                    value={props.formState.existingHealthInsurance}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={e => handleValueChange('existingHealthInsurance', e)}
                                    errors={errors && errors.existingHealthInsurance}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                />
                            </Form.Group>
                        }

                        {existingMedicareState.includes(state) &&
                            <Form.Group>
                                <p className="section-title">{getExistingMedicareLabel()}</p>
                                <StyledRadioInput
                                    name="existingMedicare"
                                    id="existingMedicare"
                                    value={props.formState.existingMedicare}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={e => handleValueChange('existingMedicare', e)}
                                    errors={errors && errors.existingMedicare}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                />
                            </Form.Group>
                        }
                       
                        {state === CALIFORNIA &&
                            <React.Fragment>
                                <Form.Group>
                                    <p className="section-title">Are you or anyone to be covered, currently covered by Medi-Cal?</p>
                                    <StyledRadioInput
                                        name="existingMediCal"
                                        id="existingMediCal"
                                        value={props.formState.existingMediCal}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('existingMediCal', e)}
                                        errors={errors && errors.existingMediCal}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>
                            </React.Fragment>
                        }

                        {state === DISTRICT_OF_COLUMBIA &&
                            <Fragment>
                                <Form.Group>
                                    <p className="section-title">Do you understand most supplemental only policies may not pay full benefits if your ACA compliant minimum essential coverage plan is not in force?</p>
                                    <StyledRadioInput
                                        name="acknowledgementMinimum"
                                        id="acknowledgementMinimum"
                                        value={props.formState.acknowledgementMinimum}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('acknowledgementMinimum', e)}
                                        errors={errors && errors.acknowledgementMinimum}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <p className="section-title">Do you understand that the benefits provided under the policy may be limited?</p>
                                    <StyledRadioInput
                                        name="acknowledgementLimited"
                                        id="acknowledgementLimited"
                                        value={props.formState.acknowledgementLimited}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('acknowledgementLimited', e)}
                                        errors={errors && errors.acknowledgementLimited}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>
                            </Fragment>
                        }


                    </Col>
                </Row>
                <div className='backnext-wrapper'>
                    <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
                </div>
            </Form>
        </Container>
    );
}

Eligibility.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

Eligibility.ValidationSchema = (plan) => {
    return object().shape({
        employmentStatus: string().when('state', {
            is: (state) => empStatusSelectedState.includes(state),
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        existingHealthInsurance: string().when('state', {
            is: (state) => existingHealthInsuranceState.includes(state),
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        existingMedicare: string().when('state', {
            is: (state) => existingMedicareState.includes(state),
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        existingMediCal: string().when('state', {
            is: CALIFORNIA,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        acknowledgementMinimum: string().when('state', {
            is: DISTRICT_OF_COLUMBIA,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        acknowledgementLimited: string().when('state', {
            is: DISTRICT_OF_COLUMBIA,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        ineligible: yuparray(
            object().shape({
                name: string().required('Name is required.'),
                numberOfChildren: string().when('name', {
                    is: (name) => name && name.includes('Dependent Child'),
                    then: string().required('This field is required.'),
                    otherwise: string().notRequired(),
                }),
                nameofChildren: yuparray().when('name', {
                    is: (name) => name && name.includes('Dependent Child'),
                    then: yuparray(
                        object().shape({
                            name: customValidators.string().isValidNameWithFiftyChar('Child Name is required.', true)
                        })
                    ),
                }),
            })
        )
    })
};

Eligibility.DefaultFormState = (prefill = false) => {
    return {
        employmentStatus: prefill ? 'No' : '',
        existingHealthInsurance: '',
        existingMedicare: '',
        existingMediCal: '',
        acknowledgementMinimum: '',
        acknowledgementLimited: '',
        ineligible: [],
        isVisible: false
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/Eligibility.js